import React, { Component } from 'react';
import Profile16 from '@carbon/icons-react/lib/user--avatar/16';
import Logout16 from '@carbon/icons-react/lib/logout/16';
import { authProvider } from '../../auth/authProvider';
import { Link,  } from 'react-router-dom'


export class BoxProfile extends Component {

    logout() {
        authProvider.logout();
    }

    render() {

        return (
            <div>
                {(this.props.isOpen ?
                    <div className="notification-profile">
                        <div className="notification-items">
                            {this.props.isUser ? 
                                <div className={"notification--items  notification--items-all"} >
                                    <div className="notification-item  notification">
                                        <div className="notification-information">
                                            <div className="expandable">
                                                <Link to={`/profile`} className="bx--underline-none" onClick={this.props.hiddenBox} >
                                                    <div><Profile16 className="notification--property" />  <div className="notification-module " >Profile</div></div>
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            : null}
                            
                            <div className={"notification--items  notification--items-all"} >
                                <div className="notification-item  notification">
                                    <div className="notification-information">
                                        <div className="expandable">
                                            <Logout16 className="notification--property" />  <div className="notification-module " onClick={this.logout}>Logout </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        </div>
                 : null)}
            </div>
        );
    }
}